"use strict";

/**
 *  Konfigurator Glasschiebewand ( snippets/product-glasschiebewand-confi.liquid ) ,
 *  API : sliding-glass-wall-* . Ablauf , Preis und Warenkorb : confi-wall.js
 */
(function (root) {
  var Wall = typeof module !== 'undefined' && module.exports ? require('./confi-wall.js') : root.ConfiWall;

  //  Einbauseite zuerst : vorne zwischen den Pfosten oder links / rechts als
  //  Seitenwand. Nur an der Seite gibt es das Keilfenster als Option , bis
  //  500 cm Wandbreite. Abgefragt werden die Höhen des Keilfensters selbst
  //  ( hohe Seite an der Hauswand , niedrige vorne ) .
  var Positions = ['front', 'left', 'right'];
  var Wedge_Sides = ['left', 'right'];
  var Wedge_Max_Width = 500;
  var position = function position(values) {
    return Positions.includes(values.position) ? values.position : 'front';
  };
  var atSide = function atSide(values) {
    return Wedge_Sides.includes(position(values));
  };
  var wedgeAllowed = function wedgeAllowed(values) {
    var width = Wall.number(values.width);
    return width === null || width <= Wedge_Max_Width;
  };
  var withWedge = function withWedge(values) {
    return atSide(values) && wedgeAllowed(values) && values.withWedgeWindow === true;
  };

  //  Glasfärbung des Keilfensters kommt von der Wand. Bronze gibt es beim
  //  Keilfenster nicht , dann gilt die eigene Auswahl ( klar , matt , grau ) .
  var Wedge_Glass_Colors = ['klar', 'matt', 'grau'];
  var wedgeGlassColor = function wedgeGlassColor(values) {
    return Wedge_Glass_Colors.includes(values.glassColor) ? values.glassColor : values['wedgeWindow.glassColor'];
  };

  //  Einbauseite in den 'properties' der API ( übersetzt , DE / NL / EN ) .
  //  Vorne wird nicht angezeigt ( confi-wall.js , withoutFrontPosition ) .
  //  Glasstärke 8 oder 10 mm ( Backend: docs/prompts/backend-gsw-glasstaerke.md ) .
  //  Rahmenfarbe und Glasstärke können per Produkt-Tag fest sein , dann hat
  //  das Auswahlfeld nur diesen Wert und ist ausgeblendet ( Snippet ) .
  var Glass_Thicknesses = [8, 10];
  var glassThickness = function glassThickness(value) {
    return Glass_Thicknesses.includes(Number(value)) ? Number(value) : 8;
  };

  //  Höhe bis 230 cm mit 8 mm , bis 250 cm nur mit 10 mm ( max im Snippet ) .
  //  Darüber wird 10 mm gewählt und 8 mm gesperrt. Unter 230 cm bleibt die
  //  Auswahl , 8 mm ist dann wieder wählbar.
  var Max_Height_8mm = 230;
  var needs10mm = function needs10mm(values) {
    var height = Wall.number(values.height);
    return height !== null && height > Max_Height_8mm;
  };
  var definition = {
    confi: 'glasschiebewand-confi',
    endpoint: 'sliding-glass-wall',
    wallType: 'slidingGlassWall',
    required: function required(values) {
      var list = ['width', 'height'];
      if (withWedge(values)) {
        list.push('wedgeWindow.heightHigh', 'wedgeWindow.heightLow');
      }
      return list;
    },
    body: function body(values) {
      var body = {
        width: Wall.number(values.width),
        height: Wall.number(values.height),
        glassColor: values.glassColor,
        glassThickness: glassThickness(values.glassThickness),
        frameColor: values.frameColor,
        position: position(values),
        underConstruction: Wall.bool(values.underConstruction),
        windSeal: values.windSeal === true
      };
      // Breite , Rahmen- und Glasfarbe übernimmt das Keilfenster von der Wand
      if (withWedge(values)) {
        body.wedgeWindow = {
          heightHigh: Wall.number(values['wedgeWindow.heightHigh']),
          heightLow: Wall.number(values['wedgeWindow.heightLow']),
          glassColor: wedgeGlassColor(values)
        };
      }
      return body;
    },
    rules: function rules(values) {
      var side = atSide(values);
      var allowed = wedgeAllowed(values);
      var active = withWedge(values);
      var tall = needs10mm(values);
      var set = {};
      // Über 500 cm entfernt das Keilfenster
      if (!allowed && values.withWedgeWindow === true) set.withWedgeWindow = false;
      if (tall) set.glassThickness = '10';
      return {
        set: set,
        hidden: {
          'thickness-for-height': !tall,
          'measure-front': side,
          'measure-side': !side,
          'wedge-window': !side,
          'wedge-window-fields': !active,
          'wedge-window-glass': !(active && !Wedge_Glass_Colors.includes(values.glassColor)),
          'wedge-window-too-wide': allowed
        },
        disabled: {
          withWedgeWindow: !allowed
        },
        disabledOptions: {
          glassThickness: tall ? ['8'] : []
        }
      };
    },
    properties: function properties(list, data) {
      return Wall.withoutFrontPosition(list, data);
    },
    fromInfo: function fromInfo(data) {
      var wedge = data.wedgeWindow || null;
      var underConstruction = data.underConstruction !== null && data.underConstruction !== undefined && data.underConstruction !== false;
      return {
        position: Positions.includes(data.position) ? data.position : wedge !== null ? 'left' : 'front',
        width: data.width,
        height: data.height,
        glassColor: data.glassColor,
        glassThickness: glassThickness(data.glassThickness),
        frameColor: data.frameColor,
        underConstruction: underConstruction ? 'true' : 'false',
        windSeal: data.windSeal !== null && data.windSeal !== undefined && data.windSeal !== false,
        withWedgeWindow: wedge !== null,
        'wedgeWindow.heightHigh': wedge ? wedge.highHeight : null,
        'wedgeWindow.heightLow': wedge ? wedge.lowHeight : null,
        'wedgeWindow.glassColor': wedge ? wedge.glassColor : null
      };
    }
  };
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = definition;
  }
  if (root && root.document) {
    root.document.addEventListener('DOMContentLoaded', function () {
      return Wall.start(definition);
    });
  }
})(typeof window !== 'undefined' ? window : null);